import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// Brand navy — matches the invoices / BOL / reports so the app and the
// documents share one professional identity.
const BRAND = "#1f3a5f";

let theme = createTheme({
  palette: {
    primary:   { main: BRAND, dark: "#162b46", light: "#34527a", contrastText: "#ffffff" },
    secondary: { main: "#2f8f7f", contrastText: "#ffffff" },
    background: { default: "#f4f6f9", paper: "#ffffff" },
    text:      { primary: "#1f2933", secondary: "#5b6b7b" },
    divider:   "#e3e8ef",
    success:   { main: "#2e7d32" },
    warning:   { main: "#ed6c02" },
    error:     { main: "#d32f2f" },
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Segoe UI", system-ui, -apple-system, Roboto, "Helvetica Neue", Arial, sans-serif',
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 700 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  components: {
    // Flat, subtle elevation everywhere (modern SaaS look).
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { backgroundImage: "none", boxShadow: "0 1px 3px rgba(16,24,40,.10)" } },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: "1px solid #e3e8ef", borderRadius: 12 } },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiDrawer: { styleOverrides: { paper: { borderRight: "1px solid #e3e8ef" } } },
    MuiTableCell: {
      styleOverrides: {
        head: { fontWeight: 700, whiteSpace: "nowrap" },
        root: { borderColor: "#eef2f6" },
      },
    },
    // Wide tables scroll horizontally instead of breaking the mobile layout.
    MuiTableContainer: { styleOverrides: { root: { overflowX: "auto" } } },
    // On phones, dialogs use nearly the full screen so forms/buttons aren't cramped.
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }) => ({
          [theme.breakpoints.down("sm")]: {
            margin: 8,
            width: "calc(100% - 16px)",
            maxWidth: "calc(100% - 16px)",
            maxHeight: "calc(100% - 16px)",
          },
        }),
      },
    },
  },
});

theme = responsiveFontSizes(theme);
export default theme;
